// src/pages/learn/sharedSources.js
// Canonical GOV.UK / Companies House sources cited across the /learn guides.
// Every regulatory claim in the pilot articles traces to one of these.
export const SRC = {
  ivRollout: {
    label: 'Companies House confirms identity verification rollout from 18 November 2025 (GOV.UK)',
    url: 'https://www.gov.uk/government/news/companies-house-confirms-identity-verification-rollout-from-18-november-2025',
  },
  verifyingGuidance: {
    label: 'Verifying your identity for Companies House (GOV.UK guidance)',
    url: 'https://www.gov.uk/guidance/verifying-your-identity-for-companies-house',
  },
  personalCodes: {
    label: 'Companies House personal codes for identity verification (GOV.UK)',
    url: 'https://www.gov.uk/guidance/companies-house-personal-codes-for-identity-verification',
  },
  verifyRoutes: {
    label: 'Verify your identity for Companies House (GOV.UK)',
    url: 'https://www.gov.uk/guidance/verify-your-identity-for-companies-house',
  },
  acspRoute: {
    label: 'Verifying with an Authorised Corporate Service Provider (ACSP) (GOV.UK)',
    url: 'https://identity.company-information.service.gov.uk/identity-verification/verifying-with-authorised-corporate-service-provider',
  },
  fees2026: {
    label: 'Companies House fees are changing from 1 February 2026 (GOV.UK)',
    url: 'https://www.gov.uk/government/news/companies-house-fees-are-changing-from-1-february-2026',
  },
  feesSchedule: {
    label: 'Companies House fees (GOV.UK — full fee schedule)',
    url: 'https://www.gov.uk/government/publications/companies-house-fees',
  },
  pscVerification: {
    label: 'Provide identity verification details for a person with significant control (GOV.UK)',
    url: 'https://www.gov.uk/guidance/provide-psc-verification',
  },
  lateFilingPenalties: {
    label: 'Penalties for filing your accounts late (GOV.UK)',
    url: 'https://www.gov.uk/annual-accounts/penalties-for-late-filing',
  },
  financialPenalties: {
    label: 'Companies House approach to financial penalties (GOV.UK)',
    url: 'https://www.gov.uk/government/publications/companies-house-approach-to-financial-penalties/companies-house-approach-to-financial-penalties',
  },
  authCodes: {
    label: 'Company authentication codes for online filing (GOV.UK)',
    url: 'https://www.gov.uk/guidance/company-authentication-codes-for-online-filing',
  },
  confirmationStatementGuidance: {
    label: 'Filing your company’s confirmation statement (GOV.UK guidance)',
    url: 'https://www.gov.uk/guidance/confirmation-statement-guidance',
  },
  strikingOff: {
    label: 'Striking off, dissolution and restoration (GOV.UK)',
    url: 'https://www.gov.uk/government/publications/striking-off-or-dissolving-a-limited-company/striking-off-or-dissolving-a-limited-company',
  },
  ivNonCompliance: {
    label: 'Companies House approach to non-compliance with mandatory identity verification (GOV.UK)',
    url: 'https://www.gov.uk/government/publications/companies-house-approach-to-non-compliance-with-mandatory-identity-verification/companies-house-approach-to-non-compliance-with-mandatory-identity-verification',
  },
  chStatistics: {
    label: 'Statistics at Companies House — late filing penalties & register activity (GOV.UK)',
    url: 'https://www.gov.uk/government/organisations/companies-house/about/statistics',
  },
  annualReport2324: {
    label: 'Companies House annual report and accounts 2023 to 2024 (GOV.UK)',
    url: 'https://www.gov.uk/government/publications/companies-house-annual-report-and-accounts-2023-to-2024/companies-house-annual-report-and-accounts-2023-to-2024',
  },
};
